import { Component } from '@angular/core';

@Component({
  selector: 'app-web-dev',
  imports: [],
  templateUrl: './web-dev.component.html',
  styleUrl: './web-dev.component.scss',
})
export class WebDevComponent {}
